import { DiscardConfirmation, RouterContext } from '../../libs/gs-component-right-rail';
import React, { useContext } from 'react';

interface Props {
  onClose: () => void;
}

export const ConfirmDiscard: React.FC<Props> = ({ onClose }) => {
  const { goBack } = useContext(RouterContext);

  return <DiscardConfirmation onCancel={goBack} onContinue={onClose} />;
};
